<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<!-- 创建学习资源对话框 -->
		<el-dialog :modal="true" :modal-append-to-body="false" :fullscreen="false" :visible.sync="centerDialogVisible"
			width="700px" center>
			<div class="dialog_title" slot="title">
				<div class="title_icon"><img src="../../../../assets/images/danghui_yellow.png" alt=""></div>
				<div class="title_text">创建学习资源</div>
			</div>
			<div class="addWrap">
				<!-- 创建学习资源 -->
				<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="资源名称：" prop="title">
						<el-input placeholder="请输入资源名称" v-model="ruleForm2.title"></el-input>
					</el-form-item>
					<el-form-item label="资源类型：" prop="bs_id">
						<el-radio-group class="addResouceItem" v-model="ruleForm2.bs_id">
							<el-radio label="3">视频</el-radio>
							<el-radio label="1">课件</el-radio>
							<el-radio label="8">文档</el-radio>
							<el-radio label="2">图片</el-radio>
							<el-radio label="4">音频</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="资源时长：" prop="durs">
						<el-input :disabled="ruleForm2.bs_id==2||ruleForm2.bs_id==1"  @input="durChange" placeholder="时" v-model="dur2"></el-input>
						&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
						<el-input :disabled="ruleForm2.bs_id==2||ruleForm2.bs_id==1"   @input="durChange" placeholder="分" v-model="dur3"></el-input>
						&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
						<el-input :disabled="ruleForm2.bs_id==2||ruleForm2.bs_id==1"   @input="durChange" placeholder="秒" v-model="dur4"></el-input>
					</el-form-item>
					<el-form-item label="资源上传:" prop="file_src">
						<div class="fileList" v-if="ruleForm2.file_src != '' && ruleForm2.file_src != null">
							<div class="fileList_left">
								<img src="../../../../assets/images/fileicon.png" alt="">
							</div>
							<div class="fileName_text">{{ fileName2 }}</div>
						</div>
					</el-form-item>
					<el-form-item class="uploadFile">
						<el-upload :data="{ token: $store.state.user.userinfo.token }" name="file" :action="$uploadFile"
							:show-file-list="false" :on-success="AddSuccess" :before-upload="beforeUpload">
							<el-button class="el_button" type="primary">{{ ruleForm2.file_src == null || ruleForm2.file_src ==
								'' ? '上传资源' : '重新上传' }}</el-button>
							<div class="tishi">说明：图片支持格式png和jpg，大小不得超过2M；视频支持格式mp4，大小不得超过200M；
								课件支持格式pptx，大小不得超过50M；文档支持格式pdf，大小不得超过20M；
								音频支持格式mp3，大小不得超过100M。</div>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm2('ruleForm')">保存</el-button>
						<el-button @click="cancelAdd">取消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<!-- 上方标题栏 -->
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
			</el-breadcrumb>
			<el-button @click="$router.push({
				path: '/ztpx'
			})" type="primary" size="small" icon="el-icon-back">返回</el-button>
		</div>
		<!-- 下方内容 -->
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<!-- 上方筛选框 -->
					<div class="selectbar">
						<div class="left_class">
							<div :style="{
								backgroundColor: getdata.bs_id == '' ? '#EA0000' : '',
								color: getdata.bs_id == '' ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = ''
dataList()">全部资源</div>
							<div :style="{
								backgroundColor: getdata.bs_id == 4 ? '#EA0000' : '',
								color: getdata.bs_id == 4 ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = 4
dataList()">视频</div>
							<div :style="{
								backgroundColor: getdata.bs_id == 1 ? '#EA0000' : '',
								color: getdata.bs_id == 1 ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = 1
dataList()">课件</div>
							<div :style="{
								backgroundColor: getdata.bs_id == 8 ? '#EA0000' : '',
								color: getdata.bs_id == 8 ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = 8
dataList()">文档</div>
							<div :style="{
								backgroundColor: getdata.bs_id == 2 ? '#EA0000' : '',
								color: getdata.bs_id == 2 ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = 2
dataList()">图片</div>
							<div :style="{
								backgroundColor: getdata.bs_id == 3 ? '#EA0000' : '',
								color: getdata.bs_id == 3 ? '#fff' : '',
							}" class="select_class_item" @click="getdata.bs_id = 3
dataList()">音频</div>
						</div>
						<div>
							<el-date-picker class="select_year" v-model="getdata.year" type="year" size="small"
								placeholder="选择年份" value-format="yyyy">
							</el-date-picker>
							<el-input placeholder="请输入内容" clearable prefix-icon="el-icon-search" style="width: 200px;"
								size="small" v-model="getdata.title">
							</el-input>
							<el-button @click="selectDataList" type="primary" size="small"
								icon="el-icon-search">查询</el-button>
							<el-button @click="toggleSelection(tableData)" type="primary" size="small"
								icon="el-icon-check">全选</el-button>
							<el-button @click="delAll" type="primary" size="small" icon="el-icon-delete">删除选中</el-button>
							<el-button type="primary" size="small" icon="el-icon-folder-add"
								@click="centerDialogVisible = true">创建学习资源</el-button>
						</div>
					</div>
					<!-- 下方内筒框有数据时显示 -->
					<div class="selectdata" v-if="tableData.length > 0">
						<!-- 左侧资源预览 -->
						<div class="selectdata_left">
							<div class="selectdata_left_title">
								<img src="../../../../assets/images/video-play.png" alt="">
								资源预览
							</div>
							<!-- 视频及pdf文档 -->
							<div class="resoucePlay" v-if="fileClass == 3 || fileClass == 8">
								<iframe style="height: 384px;width:684px; background: rgb(82,86,89);" :src="fileSrc"
									frameborder="0">
								</iframe>
							</div>
							<!-- 课件ppt -->
							<div class="resoucePlay2" v-if="fileClass == 1">
								<iframe :src="'http://view.officeapps.live.com/op/view.aspx?src=' + fileSrc"
									style="margin-top: -95px;width: 670px; height: 500px;background: rgb(82,86,89);"
									allowtransparency='yes'>
								</iframe>
							</div>
							<!-- 照片 -->
							<div class="resoucePlay2" v-if="fileClass == 2">
								<!-- <iframe 
									:src="fileSrc"
									style="height: 350px;background: rgb(82,86,89);"
									allowtransparency='yes'>
								</iframe> -->
								<img :src="fileSrc" alt="">
							</div>
							<!-- 音频 -->
							<div class="resoucePlay2" v-if="fileClass == 4">
								<div class="audio_bg"></div>
								<audio :src="fileSrc" controls></audio>
							</div>
							<!-- 自建资源编辑 -->
							<div v-if="type == 'edit'" class="resouceText">
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
									class="demo-ruleForm">
									<el-form-item label="资 源 名 称:" prop="title">
										<el-input v-model="ruleForm.title"></el-input>
									</el-form-item>

									<el-form-item label="资 源 类 型:" prop="bs_id">
										<el-radio-group v-model="ruleForm.bs_id">
											<el-radio label="3">视频</el-radio>
											<el-radio label="1">课件</el-radio>
											<el-radio label="8">文档</el-radio>
											<el-radio label="2">图片</el-radio>
											<el-radio label="4">音频</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="资 源 时 长:" prop="durs">
										<div class="edit_resouce" style="display: flex;">
											<div
												style="width: 50px;overflow: hidden;border-right: 1px solid #EEE;border-radius: 4px;">
												
												<el-input :disabled="ruleForm.bs_id==2||ruleForm.bs_id==1" style="width: 50px;" @input="durChange" placeholder="时"
													v-model="dur2"></el-input>
											</div>
											&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
											<div
												style="width: 50px;overflow: hidden;border-right: 1px solid #EEE;border-radius: 4px;">
												<el-input :disabled="ruleForm.bs_id==2||ruleForm.bs_id==1" style="width: 50px;" @input="durChange" placeholder="分"
													v-model="dur3"></el-input>
											</div> &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
											<div
												style="width: 50px;overflow: hidden;border-right: 1px solid #EEE;border-radius: 4px;">
												<el-input :disabled="ruleForm.bs_id==2||ruleForm.bs_id==1" style="width: 50px;" @input="durChange" placeholder="秒"
													v-model="dur4"></el-input>
											</div>
										</div>
									</el-form-item>
									<el-form-item label="资 源 上 传:" prop="file_src">
										<div class="fileList" v-if="ruleForm.file_src != '' && ruleForm.file_src != null">
											<div class="fileList_left">
												<img src="../../../../assets/images/fileicon.png" alt="">
											</div>
											<div class="fileName_text">{{ fileName }}</div>
										</div>
										<el-upload :data="{ token: $store.state.user.userinfo.token }" name="file"
											:action="$uploadFile" :show-file-list="false" :on-success="success"
											:before-upload="beforeUpload">
											<el-button class="el_button" type="primary">{{ ruleForm.file_src == null ||
												ruleForm.file_src == '' ? '上传资源' : '重新上传' }}</el-button>
											<div class="tishi">说明：图片支持格式png和jpg，大小不得超过2M；视频支持格式mp4，大小不得超过200M；
												课件支持格式pptx，大小不得超过50M；文档支持格式pdf，大小不得超过20M；
												音频支持格式mp3，大小不得超过100M。</div>
										</el-upload>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
										<el-button @click="resetForm('ruleForm')">取消</el-button>
									</el-form-item>
								</el-form>
							</div>
							<div v-if="type == 'show'" class="resouceText">
								<div class="top_botton">
									<el-button @click="changeFileSrc('pre')">上一个</el-button>
									<el-button @click="goEdit(selectId)" type="primary"
										icon="el-icon-edit">编辑当前资源</el-button>
									<el-button @click="changeFileSrc('next')">下一个</el-button>
								</div>
								<div class="bottom_introduce">
									<div class="bottom_introduce_title">
										<img src="../../../../assets/images/introcude_icon.png" alt="">
										专题简介
									</div>
									<div class="bottom_introduce_content">
										{{ ztIntroduct }}
									</div>
								</div>
							</div>
						</div>
						<!-- 右侧表格数据 -->
						<div class="selectdata_right">
							<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
								:default-sort="{ prop: 'date', order: 'descending' }" :border="true" :stripe="true"
								:row-style="{ height: '43px' }" :header-cell-style="{ background: '#F2F6FC' }"
								@selection-change="handleSelectionChange">
								<el-table-column type="selection">
								</el-table-column>
								<el-table-column label="序号" type="index" width="60px" align="center">
								</el-table-column>
								<el-table-column label="资源名称" sortable>
									<template slot-scope="scope">
										<div :style="{ fontWeight: scope.row.id == selectId ? '800' : '400' }"
											@click="changContent(scope.row)">{{ scope.row.title }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="bs_id_key" label="资源类别" align="center" width="116px" sortable
									show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="addtime" label="日期" align="center" sortable width="117px">
									<!-- <template slot-scope="scope">{{ scope.row.date }}
										</template> -->
								</el-table-column>
							</el-table>
							<Page :totalPage="totalPage" :pageSize="15" @changedata="changedata"></Page>
						</div>
					</div>
					<!-- 下方内筒框有无数据时显示 -->
					<div class="selectdata" v-if="tableData.length == 0">
						<div class="noContent">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// import tree from '@/components/tree.vue'
import { xxjy, dwgl } from '@/axios'
import Page from '@/components/page.vue'
import DelData from '@/components/delToast.vue'
// import AddZt from '@/components/add_zt.vue'
import { Message } from 'element-ui'
let that;
export default {
	data() {
		return {
			dur2: '',
			dur3: '',
			dur4: '',
			getdata: {
				id: this.$route.query.id,
				title: "",
				page: 1,
				year: '',
				bs_id: ''
			},
			fileUrl: '',
			// 文件名称
			fileName: '',
			// 添加资源时的文件名
			fileName2: '',
			// 编辑当前资源
			ruleForm: {
				title: '',
				sid: this.$route.query.id,
				bs_id: '',
				file_src: '',
				durs: '',
				id: '',
				file_title: ''

			},
			rules: {
				title: [
					{ required: true, message: '请输入资源名称', trigger: 'blur' },
				],
				bs_id: [
					{ required: true, message: '请选择资源类型', trigger: 'change' }
				],
				src: [
					{ required: true, message: '请上传资源', trigger: 'change' }
				],
			},
			// 新建学习资源
			ruleForm2: {
				title: '',
				sid: this.$route.query.id,
				bs_id: '',
				file_src: '',
				durs: '',
				file_title: ''
			},
			rules2: {
				title: [
					{ required: true, message: '请输入活动名称', trigger: 'blur' },
				],
				bs_id: [
					{ required: true, message: '请选择活动资源', trigger: 'change' }
				],
				file_src: [
					{ required: true, message: '请上传资源', trigger: 'blur' },
				],

			},
			// 选中的内容
			multipleSelection: [],
			// 新建专题对话框
			centerDialogVisible: false,
			// 新建专题
			formData: {
				id: "",
				dwid: this.$route.query.dwid,
				flag: this.$route.query.flag,
				status: 1,
				title: "",
				introduct: "",
				sz_img: "",
				open: 0,//默认不公开
				column_title: []
			},
			delList: [],
			showlocal: false,
			totalPage: 0,
			studyNum: 0,
			studyTime: 0,
			ztIntroduct: this.$route.query.introduct,
			// 切换内容时选中的id
			selectId: '',
			// 文件预览路径
			fileSrc: '',
			// 文件预览类型
			fileClass: '',
			type: 'show',
			tableData: [],
			addLoding: ''
		}
	},
	components: { Page, DelData },
	created() { that = this },
	computed: {

	},
	mounted() {
		let that = this
		that.$emit('selectTop', 5)
		that.dataList();

	},
	methods: {
		durChange() {
			this.ruleForm2.durs = Number(this.dur2) * 3600 + Number(this.dur3) * 60 + Number(this.dur4)
			this.ruleForm.durs = Number(this.dur2) * 3600 + Number(this.dur3) * 60 + Number(this.dur4)

		},
		// 全选
		toggleSelection(rows) {
			console.log(rows);
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		// 取消全选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 取消上传
		cancelAdd() {
			this.centerDialogVisible = false
			this.ruleForm2.title = ''
			this.ruleForm2.bs_id = ''
			this.ruleForm2.file_src = ''
			this.ruleForm2.durs = ''
			this.ruleForm2.file_title = ''

		},
		// 点击资源
		changContent(data) {
			this.selectId = data.id
			this.fileSrc = data.file_src
			this.fileClass = data.bs_id
			this.type = 'show'

		},
		// 编辑内容提交
		submitForm() {
			let that = this
			that.ruleForm.file_title = that.fileName
			console.log(that.ruleForm);
			if (
				that.ruleForm.bs_id == 1 && that.ruleForm.file_src.substring(that.ruleForm.file_src.length - 4) != 'pptx' ||
				that.ruleForm.bs_id == 2 && that.ruleForm.file_src.substring(that.ruleForm.file_src.length - 3) != 'png' ||
				that.ruleForm.bs_id == 3 && that.ruleForm.file_src.substring(that.ruleForm.file_src.length - 3) != 'mp4' ||
				that.ruleForm.bs_id == 4 && that.ruleForm.file_src.substring(that.ruleForm.file_src.length - 3) != 'mp3' ||
				that.ruleForm.bs_id == 8 && that.ruleForm.file_src.substring(that.ruleForm.file_src.length - 3) != 'pdf'
			) {
				Message({
					type: "warning",
					message: '文件类型不符合'
				})
				return
			} else if (that.ruleForm2.bs_id == 2 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) == 'jpg') {
				xxjy.updateSpecialContent(that.ruleForm).then(res => {
					if (res.code == 200) {

						that.type = 'show'
						Message({
							type: "success",
							message: '编辑内容成功'
						})
						that.dataList()
					} else {
						Message({
							type: "error",
							message: res.msg
						})
					}
				})
				return
			} else {
				xxjy.updateSpecialContent(that.ruleForm).then(res => {
					if (res.code == 200) {

						that.type = 'show'
						Message({
							type: "success",
							message: '编辑内容成功'
						})
						that.dataList()
					} else {
						Message({
							type: "error",
							message: res.msg
						})
					}
				})
			}
		},

		resetForm(formName) {
			this.type = 'show'
		},
		// 新增内容提交
		submitForm2(formName) {
			let that = this
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 文件选择类型与上传类型比较
					if (
						that.ruleForm2.bs_id == 1 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 4) != 'pptx' ||
						that.ruleForm2.bs_id == 2 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) != 'png' ||
						that.ruleForm2.bs_id == 3 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) != 'mp4' ||
						that.ruleForm2.bs_id == 4 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) != 'mp3' ||
						that.ruleForm2.bs_id == 8 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) != 'pdf'
					) {
						Message({
							type: "warning",
							message: '文件类型不符合'
						})
						return
					} else if (that.ruleForm2.bs_id == 2 && that.ruleForm2.file_title.substring(that.ruleForm2.file_title.length - 3) == 'jpg') {
						// 新增
						xxjy.addSpecialContent(that.ruleForm2).then(res => {
							if (res.code == 200) {
								Message({
									type: "success",
									message: '添加成功'
								})
							} else {
								Message({
									type: "error",
									message: res.msg
								})
							}
							that.ruleForm2.title = ''
							that.ruleForm2.bs_id = ''
							that.ruleForm2.file_src = ''
							that.ruleForm2.durs = ''
							that.ruleForm2.file_title = ''
							that.centerDialogVisible = false
							// 重新获取数据列表
							that.dataList()
						})
						return
					}
					else {
						// 新增
						xxjy.addSpecialContent(that.ruleForm2).then(res => {
							if (res.code == 200) {
								Message({
									type: "success",
									message: '添加成功'
								})
							} else {
								Message({
									type: "error",
									message: res.msg
								})
							}
							that.ruleForm2.title = ''
							that.ruleForm2.bs_id = ''
							that.ruleForm2.file_src = ''
							that.ruleForm2.durs = ''
							that.ruleForm2.file_title = ''
							that.centerDialogVisible = false
							// 重新获取数据列表
							that.dataList()

						})
					}


				} else {

					return false;
				}
			});
		},
		// 文件上传成功
		success(res, file) {
			var that = this;
			if (res.code == 200) {
				that.fileUrl = URL.createObjectURL(file.raw);
				// that.isUploaded = "重新上传"
				that.ruleForm.file_src = res.data.src
				that.ruleForm.file_title = res.data.title
				that.fileName = res.data.title
			} else {
				Message({
					type: "error",
					message: "上传失败，请检查文件或网络连接"
				})
			}
			this.addLoding.close();
		},
		// 添加内容时，文件上传成功
		AddSuccess(res, file) {
			var that = this;
			if (res.code == 200) {
				that.ruleForm2.file_src = URL.createObjectURL(file.raw);
				// that.isUploaded = "重新上传"
				that.ruleForm2.file_src = res.data.src
				that.fileName2 = res.data.title
				that.ruleForm2.file_title = res.data.title

			} else {
				Message({
					type: "error",
					message: "上传失败，请检查文件或网络连接"
				})
			}
			this.addLoding.close();
		},

		handleSelectionChange(val) {
			let that = this
			that.multipleSelection = [];

			val.forEach(item => {
				that.multipleSelection.push(item.id)
			});

		},
		// 分页查询
		changedata(val) {
			that.getdata.page = val;
			that.dataList();
		},
		// 跳转至编辑页面
		goEdit(data) {
			this.type = 'edit'
			this.bindData()
		},
		// 数据
		dataList() {
			let that = this
			xxjy.selectSpecialContent(that.getdata).then(res => {

				if (res.code == 200) {
					// 获取表格数据
					that.tableData = res.data.pagedata;

					// 改变时间格式
					that.tableData.forEach((item, index, arr) => {
						arr[index].addtime = that.$changeTime(item.addtime)
					})
					that.totalPage = res.data.count;
					// 初始化显示内容
					that.fileSrc = that.tableData[0].file_src
					that.selectId = that.tableData[0].id
					that.fileClass = that.tableData[0].bs_id
				}


			})
		},

		delAll() {
			if (that.multipleSelection.length == 0) {
				Message.warning('请先选择要删除得数据')
			} else {
				that.delData();
			}
		},
		// 部分禁用删除
		selectEnable(row, rowIndex) {
			if (row.dwid == that.$store.state.user.userinfo.id) {
				return true
			}
		},
		//	删除操作
		delData() {
			that.$refs.delDatas.showToast(res => {
				if (res) {
					xxjy.delContent({
						id: that.multipleSelection,
					}).then(res => {
						if (res.code == 200) {
							Message({
								type: 'success',
								message: '删除成功!'
							})
						} else {
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		// 删除
		del(data) {
			that.delList = [];
			that.delList = [data.id];
			that.delData();
		},
		// 编辑
		edit(data) {
			this.$router.push({
				path: '/add_nr',
				query: {
					id: data.id,
					zl_id: data.sid,
					type: 'edit',
					dwid: data.dwid,
					flag: data.flag,
				},
			})
		},
		// 导出表格
		daochu() {
			dwgl.exportPartyOrgan(that.getdata);
		},
		// 切换上一个及下一个
		changeFileSrc(type) {
			let that = this
			// 获取当前的下标
			let index = that.tableData.findIndex(item => {
				return item.id == that.selectId
			})

			if (type == 'pre') {
				if (index != 0) {
					index = index - 1
					that.fileSrc = that.tableData[index].file_src
					that.selectId = that.tableData[index].id
					that.fileClass = that.tableData[index].bs_id
				} else {
					Message({
						type: "success",
						message: '当前已是首个内容'
					})
				}

			} else {
				if (index >= that.tableData.length - 1) {
					Message({
						type: "success",
						message: '当前已是本页最后一个内容'
					})
				} else {
					index = index + 1
					that.fileSrc = that.tableData[index].file_src
					that.selectId = that.tableData[index].id
					that.fileClass = that.tableData[index].bs_id
				}

			}
			that.type = 'show'
		},
		// 编辑绑定数据
		bindData() {
			var that = this;
			xxjy.updateSpecialContent1({
				id: this.selectId,
			}).then(res => {

				if (res.code == 200) {
					that.ruleForm.title = res.data.title
					that.ruleForm.id = res.data.id
					that.ruleForm.bs_id = res.data.bs_id
					that.ruleForm.durs = res.data.durs
                    // if (Number(that.ruleForm.durs)<3600) {
					// 	that.dur2=0
					// }else{}
					// 将秒转化为时分秒
                    that.dur2=Math.floor(Number(res.data.durs/3600))
					this.dur3=Math.floor(Number(res.data.durs%3600)/60)
					this.dur4=Math.floor(Number(res.data.durs%60))

					that.ruleForm.file_src = res.data.file_src
					that.fileName = res.data.file_title
				}

			})
		},
		// 查询列表数据
		selectDataList() {
			let that = this
			that.getdata.page = 1,
				that.dataList()
		},
		// 文件上传之前
		beforeUpload(file) {
			let result = this.$limitFile(file)

			if (result == false) {
				return false
			} else {
				this.openFullScreen2()
			}
		},
		// 上传视频进度
		openFullScreen2() {
			this.addLoding = this.$loading({
				lock: true,
				text: '正在上传，请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

		},
		// 选中全部数据
		selectAll() {
			console.log(123);
			this.multipleSelection = []
			this.tableData.forEach(item => {
				this.multipleSelection.push(item.id)
			})
		}
	}
}
</script>

<style lang="scss" scoped="scoped">
.addresuoce_item_input {
	// width: 50px !important;
}

.addResouceItem {
	// background-color: pink;
	margin-top: 12px !important;
}

.datawrap {
	padding-top: 50px !important;
}

.selectbar {
	.left_class {
		display: flex;
		justify-content: start;

		.select_class_item {
			line-height: 32px;
			height: 32px;
			box-sizing: border-box;
			border-radius: 4px;
			padding: 0 16px;
			font-family: PingFangSC-Regular;
			font-size: 14px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
		}
	}
}

.wrap {
	position: relative;
	height: 100%;
	width: 100%;

	.fengmian {
		height: 86px;
		width: 150px;
		object-fit: cover;
	}
}

.selectdata {
	box-sizing: border-box;
	width: 100%;
	display: flex;
	justify-content: space-between;

	// padding: 10px;
	.selectdata_left {
		width: 684px;
		height: 704px;
		// background-color: skyblue;
		margin-right: 20px;

		.selectdata_left_title {
			height: 44px;
			line-height: 44px;
			font-family: PingFangSC-Regular;
			font-size: 14px;
			font-weight: normal;
			display: flex;
			align-items: center;
			letter-spacing: 0px;
			color: #666666;

			img {
				width: 16px;
				height: 16px;
				margin-right: 8px;
			}
		}

		.resoucePlay {
			width: 684px;
			height: 384px;
			overflow: hidden;

			// background-color: pink;
			iframe {
				width: 100%;
				// height: 100%;
			}
		}

		.resoucePlay2 {
			width: 684px;
			height: 384px;
			overflow-y: auto;

			// background-color: pink;
			iframe {
				width: 100%;
				// height: 100%;

			}

			img {
				width: 100%;
			}

			audio {
				width: 100%;

			}

			.audio_bg {
				width: 100%;
				height: 320px;
				background-image: url('../../../../assets/images/audio_bg.png');
			}
		}

		.resouceText {
			width: 100%;
			height: 276px;
			box-sizing: border-box;
			padding-top: 16px;

			.top_botton {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.bottom_introduce {
				width: 100%;
				margin-top: 40px;
				height: 20px;
				line-height: 20px;

				.bottom_introduce_title {
					width: 100%;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					display: flex;
					align-items: center;
					letter-spacing: 0px;
					color: #666666;

					img {
						height: 18px;
						width: 18px;
						margin-right: 5px;
					}
				}

				.bottom_introduce_content {
					margin-top: 15px;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					line-height: 24px;
					text-align: justify;
					/* 浏览器可能不支持 */
					letter-spacing: 0px;

					/* 纯黑 */
					color: #000000;
				}
			}

		}
	}

	.selectdata_right {
		width: 62%;
		// height: 704px;
		// background-color: red;
	}

	// 无数据时展示
	.noContent {
		width: 400px;
		height: 505px;
		background-image: url('../../../../assets/images/noContent_bg.png');
		margin-top: 143px;
		margin-left: 500px;
	}

}

.fileList {
	// width: 200px;
	margin-left: 0px;
	height: 40px;
	// background-color: pink;
	display: flex;
	align-items: center;

	.fileList_left {
		width: 16px;
		height: 16px;
		// background-color: skyblue;
		position: relative;

		img {
			position: absolute;
			top: 0px;
			width: 100%;
			height: 100%;
		}
	}

	.fileName_text {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		display: flex;
		align-items: center;
		letter-spacing: 0em;
		color: #1C76FD;
		box-sizing: border-box;
		padding-left: 5px;
	}
}

.el_button {
	display: flex;
	justify-content: start;
}

.tishi {
	text-align: left;
	font-family: PingFangSC-Regular;
	font-size: 12px;
	font-weight: normal;
	letter-spacing: 0px;
	/* Font/text-placeholder */
	color: #C0C4CC;
}

.el-upload {
	display: flex !important;
	flex-wrap: nowrap;
}

// dilog
.dialog_title {
	box-sizing: border-box;
	padding-bottom: 20px;
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #DCDFE6;

	.title_icon {
		width: 24px;
		height: 24px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.title_text {
		font-family: PingFangSC-Medium;
		font-size: 22px;
		font-weight: 800;
		text-align: center;
		letter-spacing: 0em;
		color: #EA0000;
		margin-left: 12px;
	}
}

.navbar {
	display: flex;
	justify-content: space-between;
}

.select_year {
	width: 130px !important;
	margin-right: 16px;
}

.uploadFile {
	display: flex;
	flex-direction: column;
}
</style>

